import {useEffect} from 'react';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {loadDocumentSeriesList, SeriesTypeEnum, useThunkDispatch} from '@dms/teas';

import {BusinessCaseSeriesDefinitionList} from './components/BusinessCaseSeriesDefinitionList';

export function BusinessCaseDefinition() {
  const dispatch = useThunkDispatch();

  useEffect(() => {
    dispatch(
      loadDocumentSeriesList({
        type: [SeriesTypeEnum.NEW_AND_USED_CARS_BUSINESS_CASE, SeriesTypeEnum.ACCOUNTING_INVOICE],
      })
    );
  }, [dispatch]);

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.salesSettingsBusinessCase.labels.businessCaseDefinition'),
        breadcrumbs: [
          {
            label: i18n.t('page.businessCases.title'),
            href: settingsRoutes.businessCase,
          },
        ],
      }}
      data-testid="settings-businessCases-definition"
      description={i18n.t('page.salesSettings.labels.businessCaseDefinitionDescription')}
    >
      <BusinessCaseSeriesDefinitionList />
    </SettingsTemplate>
  );
}
